import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

const ActiveHealthPlans = ({ activeHealthPlans }) => {
  const healthPlans = Array.from(activeHealthPlans.values());

  return (
    <>
      <Typography variant="h5" fontWeight="bold">
        Active Health Plans
      </Typography>
      <List
        data-testid="active-health-plan-list"
        dense
        sx={
          healthPlans.length > 0
            ? {
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "8px",
              }
            : {}
        }
      >
        {healthPlans.map((plan, index) => (
          <ListItem
            name="active-policy"
            key={index}
            sx={{ paddingTop: "1px", paddingBottom: "1px" }}
          >
            <ListItemText name="active-policy-details" primary={plan} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default ActiveHealthPlans;
